var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "step_component_wrapper"
    }
  }, [_c('div', {
    staticClass: "slot-content",
    staticStyle: {
      "padding-left": "150px"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.choice),
      expression: "choice"
    }],
    attrs: {
      "type": "radio",
      "id": "machine_check",
      "value": "machineClicked"
    },
    domProps: {
      "checked": _vm._q(_vm.choice, "machineClicked")
    },
    on: {
      "__c": function($event) {
        _vm.choice = "machineClicked"
      }
    }
  }), _vm._v("\n           " + _vm._s(_vm.labels[1]) + "\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.machineValue),
      expression: "machineValue"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin": "10px 0px 25px 5px",
      "border-radius": "2px",
      "padding": "0px 10px"
    },
    attrs: {
      "id": "model_selector",
      "name": "model",
      "type": "text",
      "disabled": !_vm.machineClicked,
      "placeholder": _vm.labels[0]
    },
    domProps: {
      "value": (_vm.machineValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.machineValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.choice),
      expression: "choice"
    }],
    attrs: {
      "type": "radio",
      "id": "index_check",
      "value": "indexClicked"
    },
    domProps: {
      "checked": _vm._q(_vm.choice, "indexClicked")
    },
    on: {
      "__c": function($event) {
        _vm.choice = "indexClicked"
      }
    }
  }), _vm._v("\n            " + _vm._s(_vm.labels[2]) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "slot-button"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.$root.logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('logout', null)))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "disabled": (!_vm.machineClicked && !_vm.indexClicked) || _vm.forwarding
    },
    on: {
      "click": _vm.forward
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$Jed.firstUpperTranslate('confirm', null)) + "\n        ")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27005f4e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loader/steps/PreSelezione.vue
// module id = 1476
// module chunks = 1